<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <h4 class="card-header-title">Tạo mới tin tức</h4>
          </div>
        </div>
        <div class="main-body mt-1">
          <div class="main-body-table">
            <el-form
              :model="mData.dataForm"
              :rules="mData.validForm"
              @submit.native.prevent
              ref="formAddNews"
              label-width="160px"
              label-position="top"
            >
              <b-row class="mb-1">
                <b-col md="2" class="pl-0">
                  <el-form-item
                    label="Ảnh bài viết"
                    prop="image"
                    class="time-attendance-photo"
                    ref="image"
                  >
                    <el-image
                      v-if="!loadImage"
                      class="avatar__image"
                      @click="
                        showDetailImage(imgUrl ? imgUrl : 'img/document.jpg')
                      "
                      :src="imgUrl ? imgUrl : 'img/document.jpg'"
                      fit="cover"
                      title="Nhấn vào để xem trước"
                    ></el-image>
                    <el-upload
                      class="upload-demo"
                      action
                      :show-file-list="false"
                      :auto-upload="false"
                      :accept="mData.fileUploadOption.Anh.accept"
                      :on-change="fn_uploadChangeFile"
                    >
                      <el-button size="small" class="btn-default">
                        Tải ảnh lên
                      </el-button>
                    </el-upload>
                  </el-form-item>
                </b-col>

                <b-col md="10" class="p-0">
                  <b-row>
                    <b-col :md="$route.query.handle == 'update' ? 4 : 6">
                      <el-form-item label="Danh mục tin tức" prop="category_id">
                        <el-select
                          v-model="mData.dataForm.category_id"
                          filterable
                        >
                          <el-option
                            v-for="item in listNewsCategory"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col :md="$route.query.handle == 'update' ? 4 : 6">
                      <el-form-item label="Nổi bật" prop="is_important">
                        <el-select
                          v-model="mData.dataForm.is_important"
                          filterable
                          @input="forceUpdateUI"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listOutStanding"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <el-form-item label="Tiêu đề bài viết" prop="title">
                        <el-input
                          type="textarea"
                          v-model="mData.dataForm.title"
                          placeholder=""
                          resize="none"
                          :autosize="{ minRows: 3, maxRows: 3 }"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12" class="editor_custom pl-0">
                  <el-form-item label="Nội dung bài viết" prop="content">
                    <ckeditor
                      v-model="mData.dataForm.content"
                      :config="editorConfig"
                      :readOnly="editorConfig.readOnly"
                       editor-url="/ckeditor/ckeditor.js"
                      @blur="fn_checkValid()"
                    ></ckeditor>
                  </el-form-item>
                </b-col>
              </b-row>
              <div class="text-center mt-3">
                <el-button round class="btn-back" @click="fn_goBack()"
                  >Quay lại</el-button
                >
                <el-button
                  round
                  class="btn-default"
                  @click="fn_submitForm()"
                  native-type="submit"
                  >Thêm mới</el-button
                >
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <el-image-viewer
      class="dialog__image-viewer"
      v-if="visibleDialogImage"
      :on-close="closeViewer"
      :url-list="[imgUrl]"
    />
  </div>
</template>

<script>
import LanguageService from "../../../../service/LanguageService";
import ExtensionService from "../../../../service/ExtensionService";
import ValidService from "../../../../service/ValidService";
import MethodService from "../../../../service/MethodService";
import EmployeeApi from "../../../../moduleApi/EmployeeApi";
import NewsApi from "../../../../moduleApi/NewsApi";
import NewsCategoryApi from "../../../../moduleApi/NewsCategoryApi";
import NewsListModel from "./NewsListModel";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  components: {
    ElImageViewer,
  },
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      editorConfig: {
        height: 300,
        readOnly: false,
        editorplaceholder: "Nhập nội dung ở đây...",
        extraPlugins: "colorbutton,colordialog,justify,editorplaceholder",
        removeButtons: 'Save,Print,NewPage',
        // removePlugins: 'notification,notificationaggregator,about,elementspath,scayt,showborders',
        // The configuration of the editor.
        toolbarGroups: [
          { name: "clipboard", groups: ["undo"] },
          { name: "editing", groups: ["find", "selection", "spellchecker"] },
          { name: "links" },
          { name: "insert" },
          { name: "forms" },
          { name: "tools" },
          { name: "document", groups: ["mode", "document", "doctools"] },
          { name: "others" },
          { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
          {
            name: "paragraph",
            groups: ["list", "indent", "blocks", "align", "bidi"],
          },
          { name: "styles" },
          { name: "colors" },
          { name: "about" },
        ],
      },
      mData: {
        id: null,
        moduleName: "News", //required
        dataForm: MethodService.copyObject(NewsListModel.dataForm),
        validForm: NewsListModel.validForm,
        tableRules: MethodService.copyObject(NewsListModel.tableRules),
        dataDefault: {
          listFeature: MethodService.getListFeatures(),
          listOutStanding: NewsListModel.listOutStanding,
          listNewsStatus: NewsListModel.listNewsStatus,
          listEmployee: [],
        },
        currentUser: MethodService.getCurrentUser(),
        currentCompany: MethodService.getCompanyInfo(),
        companyInfo: {},

        fileUploadOption: {
          dialogImageUrl: "",
          dialogVisible: false,
          Anh: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
        },
      },
      imgUrl: "",
      loadImage: false,
      visibleDialogImage: false,
      listNewsCategory: [],
      isCreator: false,
    };
  },

  
  methods: {
    fn_checkValid() {
      if (this.mData.dataForm.content)
        this.$refs["formAddNews"].clearValidate("content");
      else this.$refs["formAddNews"].validateField("content");
    },

    async fn_getListEmployee() {
      const employeeApiRes = await EmployeeApi.list({
        filters: "disabled=false",
        limit: 9999,
      });
      if (employeeApiRes.result && employeeApiRes.result.length > 0) {
        this.mData.dataDefault.listEmployee = employeeApiRes.result;
      }
    },

    async fn_getListNewsCategory() {
      const newsCategoryApiRes = await NewsCategoryApi.list({
        filters: "disabled=false",
        limit: 9999,
      });
      if (newsCategoryApiRes.result) {
        this.listNewsCategory = newsCategoryApiRes.result;
      }
    },

    async fn_uploadChangeFile(file, fileList) {
      if (file && file.name) {
        if (!this.checkTypeImagae(file.name)) {
          window.toastr.warning("Ảnh phải có định dạng là png, jpg hoặc jpeg")
          this.mData.fileUploadOption.Anh.fileList = []
          return
        }
      }
      if (MethodService.checkMaxFileSize(file, 10)) {
        window.toastr.warning("Ảnh tải lên có dung lương tối đa không quá 10MB")
        this.mData.fileUploadOption.Anh.fileList = []
        return
      }
      ExtensionService.upload(file, "File_News")
        .then((res) => {
          this.loadImage = true;
          this.mData.dataForm.image = res.result;
          this.imgUrl = ExtensionService.urlImg + res.result;

          this.mData.fileUploadOption.Anh.fileList = fileList;
          this.$refs["formAddNews"].clearValidate("image");
          if (this.mData.dataForm.image) {
            this.mData.validForm.image = [];
          }
          this.loadImage = false;
        })
        .catch((error) => {
          this.loadImage = false;
          this.mData.validForm.image = [ValidService.requiredChange];
          this.$refs["formAddNews"].clearValidate("image");
          window.toastr.error("Có lỗi xảy ra. Vui lòng thử lại");
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },

    checkTypeImagae(fileName) {
      let lastIndexOfDot = fileName.lastIndexOf(".");
      let fileType = fileName.substr(lastIndexOfDot + 1, fileName.length);
      let typeImage = ["png", "jpg", "jpeg"];
      return typeImage.includes(fileType.toLowerCase())
    },

    showDetailImage(url) {
      this.imgUrl = url;
      setTimeout(() => {
        this.visibleDialogImage = true;
      }, 100);
    },

    closeViewer() {
      this.visibleDialogImage = false;
    },

    beforeCloseDialogImage() {
      this.imgUrl = "";
      this.visibleDialogImage = false;
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      resData.forEach((item) => {
        if (item.category_id) {
          const category = this.listNewsCategory.find(
            (o) => o.id == item.category_id
          );
          item.category_name = category ? category.name : "";
        }
        if (item.creator_id) {
          const person = this.listNewsCategory.find(
            (o) => o.id == item.creator_id
          );
          item.creator_name = person
            ? person.name
            : item.creator_id == this.mData.currentCompany.id
            ? this.mData.currentCompany.name.name_vi
            : "";
        }
        item.status_name =
          item.status == "WAITING_APPROVER"
            ? "Chờ duyệt"
            : item.status == "REQUEST_EDIT"
            ? "Yêu cầu chỉnh sửa"
            : item.status == "APPROVERED"
            ? "Đã duyệt"
            : "";
      });
      return resData;
    },

    fn_submitForm() {
      this.$refs["formAddNews"].validate(async (valid) => {
        if (!valid) return false;
        try {
          let data = this.mData.dataForm;
          if (!data.content) {
            window.toastr.warning("Vui lòng nhập nội dung bài viết");
            return;
          } else {
            data.content = data.content.trim();
          }
          if (data.title) {
            data.title = data.title.trim();
          }
          data.creator_id = this.mData.currentUser.id;
          data.status = "WAITING_APPROVER";
          await NewsApi.create(data);
          await this.fn_goToNewsList();
        } catch (error) {
          // console.log("error", error);
          window.toastr.error("Thêm mới thất bại");
        }
      });
    },

    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(NewsListModel.dataForm);
      this.imgUrl = null;
      this.$refs["formAddNews"].resetFields();
    },

    fn_goBack() {
      this.$router.go(-1);
    },

    fn_goToNewsList() {
      this.$router.push({ name: "Admin-News-list" });
    },

    forceUpdateUI() {
      this.$forceUpdate();
    },
  },

  //run after render view
  async created() {
    this.mData.validForm.image = [ValidService.requiredChange];
    await this.fn_getListEmployee();
    await this.fn_getListNewsCategory();
  },

};
</script>
<style lang="scss" scoped>
.fade-enter-active {
  transition: all 0.2s ease;
}
.fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-enter,
.fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.icon {
  cursor: pointer;
}
::v-deep .isax-setting-2 {
  transition: 0.2s ease;
  &:hover {
    color: var(--orange);
  }
}
::v-deep .el-input-number {
  .el-input__inner {
    text-align: left;
  }
  .el-input-number__decrease,
  .el-input-number__increase {
    border: none;
    background: transparent;
    line-height: 20px !important;
  }
}
::v-deep .content {
  overflow: hidden;
  text-overflow: ellipsis;
}
:v-deep .time-attendance-photo {
  margin-bottom: 15px;
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
.upload-demo {
  margin-top: 10px !important;
  width: fit-content;
  margin: 0 auto;
}
.upload-demo .el-upload .el-button {
  padding: 5px 23px;
  border-radius: 5px !important;
}
.avatar__image {
  max-width: 100%;
  height: 120px;
  left: 50%;
  transform: translateX(-50%);
  :hover {
    cursor: pointer;
  }
}
.icon24-Stamp {
  font-size: inherit;
}

::v-deep .editor_custom {
  .ql-editor {
    background-color: #fff;
  }
  .ql-picker {
    margin-top: -11px;
  }
  .ql-color-picker,
  .ql-align {
    margin-top: -15px;
  }
  .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
    margin-top: -3px;
  }
}
.cursor-notAllow {
  cursor: not-allowed !important;
}
::v-deep .hide-toolbar {
  .ql-toolbar {
    padding: 0;
    border-bottom: hidden;
    span {
      display: none;
    }
  }
  .ql-editor {
    cursor: not-allowed;
  }
}
</style>
<style>
.cke_notification_warning {
  display: none !important;
}
</style>
